// @ts-strict-ignore
// @ts-check
import {objToQueryString} from 'common/util';
import {apiClient} from 'common/util/api-client';

// custom-alert api consumers expect {error, status} result rather than an error to be thrown  ¯\_(ツ)_/¯
/* eslint-disable local-rules/deprecated-member-access */

const processResponse = (response) => {
  if (response.ok || response.status === 200) {
    return response.json().then((results) => results.results);
  }
  return response.json().then((results) => {
    console.error(response.status, results.error);
    return {
      error: results.error,
      status: response.status,
    };
  });
};

const encodeBody = (body) => {
  return body && JSON.stringify(body);
};

const fetch = (method, url, body) => {
  if (method === `GET`) {
    return apiClient.fetch(url, {method});
  }
  return apiClient.fetch(url, {method, body: encodeBody(body)});
};

export class ProjectApi {
  constructor(projectId) {
    this.baseUrl = `/api/app/projects/${projectId}`;
  }

  getGrantedUsersForProject() {
    const url = `${this.baseUrl}/granted-users`;
    return fetch(`GET`, url).then((response) => processResponse(response));
  }
}

export class UserApi {
  getSelf() {
    return fetch(`GET`, `/api/app/me`).then((response) => processResponse(response));
  }
}

export class CustomAlertApi {
  constructor(projectId, workspaceId = null) {
    if (workspaceId) {
      this.baseUrl = `/api/app/workspaces/${workspaceId}/alerts/custom/`;
    } else {
      this.baseUrl = `/api/app/projects/${projectId}/alerts/custom/`;
    }
  }

  loadCustomAlerts(
    params = {
      skip_user_filter: false,
    },
  ) {
    const queryString = objToQueryString(params);
    return fetch(`GET`, `${this.baseUrl}?${queryString}`).then((response) => processResponse(response));
  }

  loadCustomAlertsForBookmark(bookmarkId) {
    return fetch(`GET`, `${this.baseUrl}?bookmark_id=${bookmarkId}`).then((response) => processResponse(response));
  }

  createCustomAlert(bookmarkId, alertParams = {}) {
    return fetch(`POST`, this.baseUrl, {
      bookmark_id: bookmarkId, // eslint-disable-line camelcase
      paused: false,
      ...alertParams,
    }).then((response) => processResponse(response));
  }

  updateCustomAlert(alertId, alertParams = {}) {
    const url = `${this.baseUrl}${alertId}`;
    return fetch(`PATCH`, url, alertParams).then((response) => processResponse(response));
  }
}

export class EventAlertApi {
  constructor(projectId) {
    this.baseUrl = `/api/app/projects/${projectId}/alerts/custom/events/`;
  }

  loadEventsAlert() {
    return fetch(`GET`, `${this.baseUrl}`).then((response) => processResponse(response));
  }

  updateEventsAlert(alertParams = {}) {
    return fetch(`POST`, this.baseUrl, {
      ...alertParams,
    }).then((response) => processResponse(response));
  }
}

export const customAlertApi = (projectId, workspaceId) => new CustomAlertApi(projectId, workspaceId);
export const eventAlertApi = (projectId) => new EventAlertApi(projectId);
export const userApi = () => new UserApi();
export const projectApi = (projectId) => new ProjectApi(projectId);
